/**
 * ThemeToggle: segmented control for the appearance theme (Light / Dark /
 * System). Reads and updates the choice via useTheme(). Each option is a native
 * button with aria-pressed reflecting the active choice; icons are decorative
 * and the accessible name comes from aria-label.
 */

import { useTheme, type ThemeChoice } from "../lib/theme-context";
import SunIcon from "../icons/SunIcon";
import MoonIcon from "../icons/MoonIcon";
import MonitorIcon from "../icons/MonitorIcon";
import styles from "./ThemeToggle.module.css";

const OPTIONS: { value: ThemeChoice; label: string; Icon: typeof SunIcon }[] = [
  { value: "light", label: "Light", Icon: SunIcon },
  { value: "dark", label: "Dark", Icon: MoonIcon },
  { value: "system", label: "System", Icon: MonitorIcon },
];

export default function ThemeToggle() {
  const { choice, setChoice } = useTheme();

  return (
    <div className={styles.group} role="group" aria-label="Theme">
      {OPTIONS.map(({ value, label, Icon }) => {
        const active = choice === value;
        return (
          <button
            key={value}
            type="button"
            className={`${styles.button} ${active ? styles.active : ""}`}
            aria-label={`${label} theme`}
            aria-pressed={active}
            onClick={() => setChoice(value)}
          >
            <Icon className={styles.icon} />
          </button>
        );
      })}
    </div>
  );
}
